document.addEventListener('DOMContentLoaded', function () {
  const personalizarRadio = document.querySelector('input[value="Customize"], input[value="Personalizar"]');
  const naoPersonalizarRadio = document.querySelector('input[value="No Customization"], input[value="Não Personalizar"]');

  const campoPersonalizacao = document.querySelector("p.line-item-property__field");

  // Lógica de exibição
  function toggleCampos() {
    if (personalizarRadio && personalizarRadio.checked) {
      campoPersonalizacao.style.display = 'block';
    } else {
      campoPersonalizacao.style.display = 'none';
    }
  }

  personalizarRadio?.addEventListener('change', toggleCampos);
  naoPersonalizarRadio?.addEventListener('change', toggleCampos);

  toggleCampos(); // Inicializa corretamente no carregamento
});
